// extracted by mini-css-extract-plugin
export var postContent__content = "style-module--post-content__content--deeee";
export var postContent__img = "style-module--post-content__img--8286a";
export var postContent__intro = "style-module--post-content__intro--0896a";
export var postContent__summary = "style-module--post-content__summary--eb0d9";